import { render, staticRenderFns } from "./QuestionsListHeader.vue?vue&type=template&id=10616e2e&scoped=true&"
import script from "./QuestionsListHeader.vue?vue&type=script&lang=js&"
export * from "./QuestionsListHeader.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsListHeader.vue?vue&type=style&index=0&id=10616e2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10616e2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
